import qs from 'qs';

const stringifyOptions = {
  arrayFormat: 'repeat',
  skipNulls: true,
};

const parseOptions = {
  ignoreQueryPrefix: true,
};

export const parseQuery = (search = '') => qs.parse(search, parseOptions);

export const stringifyQuery = (query = {}) => qs.stringify(query, stringifyOptions);
